module.exports = __webpack_public_path__ + "static/yaatra-9b9d14da4506b09d385fc4c143e4687e.png";